import { useQueryClient } from '@tanstack/react-query';
import useApiMutation from '_api/mutations/useApiMutation';
import { GET_ALL_HOSPITALS_KEY, GET_HOSPITAL_BY_ID_KEY } from '_api/queries/hospital';

export const DELETE_HOSPITAL_KEY = 'delete-hospital';

export const useDeleteHospital = () => {
  const queryClient = useQueryClient();
  return useApiMutation<{}, { hospitalId: number }>(
    ({ hospitalId }) => `/hospital/${hospitalId}`,
    'delete',
    {},
    {
      mutationKey: [DELETE_HOSPITAL_KEY],
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [GET_ALL_HOSPITALS_KEY] });
        queryClient.invalidateQueries({ queryKey: [GET_HOSPITAL_BY_ID_KEY] });
      },
    },
  );
};
